import { render, staticRenderFns } from "./CustomerDebtListItem.vue?vue&type=template&id=37e63957&lang=pug&"
import script from "./CustomerDebtListItem.vue?vue&type=script&lang=js&"
export * from "./CustomerDebtListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports